/*
 * Project: BookingEngine
 * Module: components/booking/confirmation/Thanks.js
 * vim:ft=javascript.jsx:
 * @flow
 */
import React from 'react';
import BookingDetails from '../mybooking/BookingDetails';

const Thanks = (props) => (
  <BookingDetails {...props} showThanks />
);

export default Thanks;
